import { Component } from "@angular/core";

@Component({
  selector: "app-contact-strip",
  templateUrl: "./contact-strip.component.html",
  styleUrls: ["./contact-strip.component.scss"],
  host: { class: "ion-content-stretched" },
})
export class ContactStripComponent {}
